export default __webpack_public_path__ + "static/Calibre-SemiboldItalic-5f04bffe7ce988169806d66e417a966a.woff2";